<template>
    <div class="redirect-screen">
        <div class="loading">正在跳转...</div>
    </div>
</template>

<script>
export default {
    name: "dormitoryCheckInScreen",
    created() {
        const { id } = this.$route.query
        let url = ''
        switch (id) {
            case '1':
                url = `https://yxy.wxztc.com.cn:8000/#/dormitoryCheckInScreen?schoolId=4780867590881281&bpProgramId=5214095725101056&buildingId=5214040036376576`
                break;
            case '2':
                url = `https://yxy.wxztc.com.cn:8000/#/dormitoryCheckInScreen?schoolId=4780867590881281&bpProgramId=5214095725101056&buildingId=5214040036638720`
                break;
            case '3':
                url = `https://yxy.wxztc.com.cn:8000/#/dormitoryCheckInScreen?schoolId=4780867590881281&bpProgramId=5214095725101056&buildingId=5214040036933632`
                break;
            case '4':
                url = `https://yxy.wxztc.com.cn:8000/#/dormitoryCheckInScreen?schoolId=4780867590881281&bpProgramId=5214095725101056&buildingId=5214040037163008`
                break;
        }
        window.location.href = url
    }
}
</script>

<style scoped>
.redirect-screen {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #f5f5f5;
}

.loading {
    font-size: 16px;
    color: #999;
}
</style>